const detail = [
  {
    path: 'configcenter/errorTask/details',
    activePath: 'configcenter/errorTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/importBillMoneyWeight',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'errorTask/add',
    activePath: 'taskWorkbench/index'
  },
  {
    path: 'errorTask/detail',
    activePath: 'taskWorkbench/index'
  },
  {
    path: 'crossBorder/routeOperation/uploadSI',
    activePath: 'crossBorder/routeOperation/lclStowage'
  },
  {
    path: 'hwly/drivingLog/add',
    activePath: 'hwly/drivingLog/list'
  },
  {
    path: 'hwly/drivingLog/edit',
    activePath: 'hwly/drivingLog/list'
  },
  {
    path: 'hwly/drivingLog/detail',
    activePath: 'hwly/drivingLog/list'
  },
  {
    path: 'serviceProvider/addContract',
    activePath: 'serviceProvider/information'
  },
  {
    path: 'crossBorder/routeOperation/importBill',
    activePath: 'crossBorder/routeOperation/lclStowage'
  },
  {
    path: 'airbooking/cabinManagement/detail',
    activePath: 'airbooking/cabinManagement'
  },
  {
    path: 'airbooking/cabinManagement/add',
    activePath: 'airbooking/cabinManagement'
  },
  {
    path: 'airbooking/cabinManagement/edit',
    activePath: 'airbooking/cabinManagement'
  },
  {
    path: 'airbooking/cabinManagement/multiAdd',
    activePath: 'airbooking/cabinManagement'
  },
  {
    path: 'airbooking/cabinAllocation/edit',
    activePath: 'airbooking/cabinAllocation'
  },
  {
    path: 'airbooking/airWaybill/upload',
    activePath: 'airbooking/airWaybill'
  },
  {
    path: 'oceanFreightBooking/workbench/bookingDetail',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/bookingChange',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/bookingEdit',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/siDetail',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/siEdit',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/siAdd',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/addVGM',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/workbench/editVGM',
    activePath: 'oceanFreightBooking/workbench'
  },
  {
    path: 'oceanFreightBooking/bookingDetail',
    activePath: 'oceanFreightBooking/booking'
  },
  {
    path: 'oceanFreightBooking/oceanTransitTime/add',
    activePath: 'oceanFreightBooking/oceanTransitTime'
  },
  {
    path: 'oceanFreightBooking/oceanTransitTime/edit',
    activePath: 'oceanFreightBooking/oceanTransitTime'
  },

  {
    path: 'crossBorder/portDeliveryOrder/add',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'crossBorder/portDeliveryOrder/edit',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'crossBorder/portDeliveryOrder/detail',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/detail',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/edit',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/importTrace',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/add',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'serviceProvider/largeServiceMappingAdd',
    activePath: 'serviceProvider/largeServiceMapping'
  },
  {
    path: 'serviceProvider/largeServiceMappingEdit',
    activePath: 'serviceProvider/largeServiceMapping'
  },
  {
    path: 'firstDriverCollection/editPickupSchedule',
    activePath: 'firstDriverCollection/pickupScheduleManagement'
  },
  {
    path: 'firstDriverCollection/transportTaskInfo',
    activePath: 'firstDriverCollection/transportTask'
  },
  {
    path: 'firstDriverCollection/createTransportTask',
    activePath: 'firstDriverCollection/collectionList'
  },
  {
    path: 'firstDriverCollection/addCollection',
    activePath: 'firstDriverCollection/collectionList'
  },
  {
    path: 'firstDriverCollection/checkCollection',
    activePath: 'firstDriverCollection/collectionList'
  },
  {
    path: 'booking/bookingInfo/bookingSpecifics',
    activePath: 'booking/bookingInfo/showBookingInfo'
  },
  {
    path: 'crossBorder/routeOperation/lclStowageInfo',
    activePath: 'crossBorder/routeOperation/lclStowage'
  },
  {
    path: 'crossBorder/supplierServiceOperation/excelImport',
    activePath: 'crossBorder/supplierServiceOperation/placeOrdersForCustomers'
  },
  {
    path: 'crossBorder/supplierServiceOperation/portBatch',
    activePath: 'crossBorder/supplierServiceOperation/placeOrdersForCustomers'
  },
  {
    path: 'crossBorder/supplierServiceOperation/manualEntry',
    activePath: 'crossBorder/supplierServiceOperation/placeOrdersForCustomers'
  },
  {
    path: 'tcsc/warehouseDeliveryOrder/detail',
    activePath: 'tcsc/warehouseDeliveryOrder/list'
  },
  {
    path: 'tcsc/portDeliveryOrder/detail',
    activePath: 'tcsc/portDeliveryOrder/list'
  },
  {
    path: 'tcsc/trunkLineOrder/detail',
    activePath: 'tcsc/trunkLineOrder/list'
  },
  {
    path: 'tcsc/trunkLineOrder/add',
    activePath: 'tcsc/trunkLineOrder/list'
  },
  {
    path: 'crossBorder/supplierServiceOperation/importBill',
    activePath: 'crossBorder/supplierServiceOperation/crossBorderList'
  },
  {
    path: 'crossBorder/supplierServiceOperation/msg',
    activePath: 'crossBorder/supplierServiceOperation/crossBorderList'
  },
  {
    path: 'crossBorder/portDeliveryOrder/detail',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'crossBorder/portDeliveryOrder/add',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'crossBorder/portDeliveryOrder/edit',
    activePath: 'crossBorder/portDeliveryOrder/list'
  },
  {
    path: 'tcsc/capacityOrder/detail',
    activePath: 'tcsc/capacityOrder/list'
  },
  {
    path: 'tcsc/capacityOrder/add',
    activePath: 'tcsc/capacityOrder/list'
  },
  {
    path: 'tcsc/waybill/detail',
    activePath: 'tcsc/waybill/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/detail',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/edit',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/importTrace',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'tcsc/mainRouteTransTask/add',
    activePath: 'tcsc/mainRouteTransTask/list'
  },
  {
    path: 'TCManage/carManageNewEdit',
    activePath: 'TCManage/carManage'
  },
  {
    path: 'TCManage/carManageNewAdd',
    activePath: 'TCManage/carManage'
  },
  {
    path: 'hwly/Workbench/demandAdd',
    activePath: 'hwly/Workbench/list'
  },
  {
    path: 'hwly/Workbench/batchDispatch',
    activePath: 'hwly/Workbench/list'
  },
  {
    path: 'hwly/demand/detail',
    activePath: 'hwly/demand/list'
  },
  {
    path: 'hwly/task/detail',
    activePath: 'hwly/task/list'
  },
  {
    path: 'tcsc/logisticsPlan/detail',
    activePath: 'tcsc/logisticsPlan/list'
  },
  {
    path: 'tcsc/logisticsPlan/add',
    activePath: 'tcsc/logisticsPlan/list'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationSingleList/details',
    activePath: 'transportation/transportationDocumentServices/transportationSingleList'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/info',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/createTransNeedBill',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/editTransNeedBill',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/mergeWaybill',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/separateCar',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/overseasMergeWaybill',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/transportationDocumentServices/transportationDocument/overseasSplitWaybill',
    activePath: 'transportation/transportationDocumentServices/transportationDocument'
  },
  {
    path: 'transportation/taskManageServices/taskListManage/info',
    activePath: 'transportation/taskManageServices/taskListManage'
  },
  {
    path: 'transportation/taskManageServices/taskListManageOverseasSendCar',
    activePath: 'transportation/taskManageServices/taskListManage'
  },
  {
    path: 'transportation/basicData/exportReportTemplateAdd',
    activePath: 'transportation/basicData/exportReportTemplate'
  },
  {
    path: 'transportation/basicData/exportReportTemplateEdit',
    activePath: 'transportation/basicData/exportReportTemplate'
  },
  {
    path: 'serviceProvider/scatterFilings/details',
    activePath: 'serviceProvider/scatterFilings'
  },
  {
    path: 'serviceProvider/scatterFilings/editAddInquiry',
    activePath: 'serviceProvider/scatterFilings'
  },
  {
    path: 'contract/view',
    activePath: 'contract/list'
  },
  {
    path: 'contract/edit',
    activePath: 'contract/list'
  },
  {
    path: 'contract/editSupplementaryAgreement',
    activePath: 'contract/list'
  },
  {
    path: 'contract/supplementaryAgreement',
    activePath: 'contract/list'
  },
  {
    path: 'contract/add',
    activePath: 'contract/list'
  },
  {
    path: 'TCManage/carplan/create',
    activePath: 'TCManage/carplan/list'
  },
  {
    path: 'TCManage/carplan/view',
    activePath: 'TCManage/carplan/list'
  },
  {
    path: 'TCManage/carplan/edit',
    activePath: 'TCManage/carplan/list'
  },
  {
    path: 'supplement/payMethodModifyEdit',
    activePath: 'supplement/payMethodModify'
  },
  {
    path: 'configcenter/merchantAndEquipmentDetai',
    activePath: 'configcenter/merchantAndEquipment'
  },
  {
    path: 'configcenter/merchantAndEquipmentEdit',
    activePath: 'configcenter/merchantAndEquipment'
  },
  {
    path: 'configcenter/merchantAndEquipmentAdd',
    activePath: 'configcenter/merchantAndEquipment'
  },
  {
    path: 'configcenter/automatedEquipmentEditV2',
    activePath: 'configcenter/automatedEquipmentV2'
  },
  {
    path: 'configcenter/automatedEquipmentAddV2',
    activePath: 'configcenter/automatedEquipmentV2'
  },
  {
    path: 'configcenter/automatedEquipmentDetailV2',
    activePath: 'configcenter/automatedEquipmentV2'
  },
  {
    path: 'configcenter/autoDispatchPlanEdit',
    activePath: 'configcenter/autoDispatchPlan'
  },
  {
    path: 'configcenter/autoDispatchPlanAdd',
    activePath: 'configcenter/autoDispatchPlan'
  },
  {
    path: 'configcenter/autoDispatchPlanDetail',
    activePath: 'configcenter/autoDispatchPlan'
  },
  {
    path: 'operationsCenter/unifiedPersonnelEfficiencyDashboardDetails',
    activePath: 'operationsCenter/unifiedPersonnelEfficiencyDashboard'
  }
]

export default detail
